import { DealershipContext } from "@/app/_components/context/dealership-context";
import { UserContext } from "@/app/_components/context/user-context";
import { useCallback, useContext, useMemo } from "react";

export function usePermissions() {
  const { getPrimaryUserGroup, user } = useContext(UserContext);
  const { currentDealership } = useContext(DealershipContext);

  const userPermissions = useMemo(() => {
    if (!currentDealership || !user) return [];

    let userSpecificPerms: string[] = [];
    const primaryUserGroup = getPrimaryUserGroup(currentDealership.id);
    if (user.permissions && user.permissions[currentDealership.id]) {
      userSpecificPerms = user.permissions[currentDealership.id];
    }

    if (!primaryUserGroup) return [];

    const merged = [...userSpecificPerms, ...primaryUserGroup.permissions];

    return (
      merged.filter((value, pos) => {
        return merged.indexOf(value) === pos;
      }) || []
    );
  }, [currentDealership, user, getPrimaryUserGroup]);

  const hasPermission = useCallback(
    (permission: string) => {
      return userPermissions.includes(permission);
    },
    [userPermissions],
  );

  return {
    userPermissions,
    hasPermission,
  };
}
